import React from "react";
import { ArrowLeft } from "lucide-react";

// Shared frame for the pages before sign-in (same card as the Login page):
// logo, optional back arrow, optional step progress, title and content.
export const inputClass = "auth-input";

export const primaryButtonClass = "auth-btn-primary";

export const secondaryButtonClass = "auth-btn-secondary";

export const Field = ({ label, hint, children }) => (
  <div>
    <label className="auth-label">{label}</label>
    {children}
    {hint ? <p className="mt-1.5 text-xs text-[#857A63]">{hint}</p> : null}
  </div>
);

export const FormError = ({ children }) =>
  children ? (
    <div className="p-4 bg-red-50 border border-red-200 rounded-[12px]" role="alert">
      <p className="text-sm text-red-600">{children}</p>
    </div>
  ) : null;

const AuthShell = ({ title, subtitle, step, steps, onBack, children }) => (
  <div className="auth-page">
    <img src="/assets/clockout2.png" alt="Clock-out" className="auth-logo" />

    <div className="auth-card">
      {onBack || steps ? (
        <div className="flex items-center gap-3 mb-5">
          {onBack ? (
            <button
              type="button"
              onClick={onBack}
              aria-label="Back"
              className="h-9 w-9 shrink-0 flex items-center justify-center rounded-[10px] text-[#4A4234] hover:bg-[#1C1A14]/5 transition-colors"
            >
              <ArrowLeft size={20} />
            </button>
          ) : null}
          {steps ? (
            <div
              className="flex flex-1 gap-1.5"
              role="progressbar"
              aria-label={`Step ${step + 1} of ${steps}`}
              aria-valuemin={1}
              aria-valuemax={steps}
              aria-valuenow={step + 1}
            >
              {Array.from({ length: steps }, (_, i) => (
                <div
                  key={i}
                  className={`h-1.5 flex-1 rounded-full ${i <= step ? "bg-[#FFC81E]" : "bg-[#EADFC6]"}`}
                />
              ))}
            </div>
          ) : null}
        </div>
      ) : null}

      <div className="text-center mb-7">
        <h1 className="auth-title">{title}</h1>
        {subtitle ? <p className="auth-subtitle">{subtitle}</p> : null}
      </div>

      {children}
    </div>

    <p className="auth-footer">
      © {new Date().getFullYear()} Talk Nerdy To Me Consultancy Ltd. All rights reserved.
    </p>
  </div>
);

export default AuthShell;